import { useState } from 'react';
import { Button, Paper } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import { columns } from './grid-columns';
import { DivisionForm } from './division.form';
import { divisionFormSchema } from './division-form.schema';
import { Division } from '../../../models/masters/division';
import { SiTrackPage } from '../../../components/si-track-page';
import { SiTrackGrid } from '../../../components/si-track-grid/si-track-grid';
import { divisionApiKeyStore } from '../../../api/masters/division-api-key-store';
import { SaveHookFormDialog } from '../../../components/save-hook-form.dialog';
import { GuardedComponent } from '../../../components/guarded-component';
import { UserPermissionName } from '../../../models/user-permission-name';

const styling = {
  paperStyle: { padding: '20px', borderRadius: '20px' },
};

export const DivisionPage = () => {
  const [editItem, setEditItem] = useState<Partial<Division>>();

  const handleEditDivision = (division: Division) => {
    setEditItem(division);
  };
  const handleEditClose = () => {
    setEditItem(undefined);
  };
  const handleCreateDivision = () => {
    setEditItem({ sendEmailReminder: false, isActive: true });
  };

  return (
    <SiTrackPage
      title="Divisions"
      actionButton={
        <GuardedComponent requiredPermissions={[UserPermissionName.ADD_DIVISION]}>
          <Button
            size="small"
            variant="contained"
            disableElevation={true}
            startIcon={<AddIcon />}
            onClick={handleCreateDivision}
          >
            Add Division
          </Button>
        </GuardedComponent>
      }
    >
      <Paper elevation={0} style={styling.paperStyle}>
        <SiTrackGrid
          fileTitle='division'
          dataItemKey="divisionID"
          columns={columns}
          queryConfig={divisionApiKeyStore.getDivisions()}
          onEdit={handleEditDivision}
          deleteMutationConfig={(deleteItem) => divisionApiKeyStore.deleteDivision(deleteItem.divisionID)}
          actionPermissions={{
            edit: UserPermissionName.EDIT_DIVISION,
            delete: UserPermissionName.DELETE_DIVISION,
            export: UserPermissionName.DOWNLOAD_GRID,
          }}
        />
        {editItem && (
          <SaveHookFormDialog
            title={editItem.divisionID ? 'UPDATE DIVISION' : 'CREATE DIVISION'}
            config={{
              saveConfig: editItem.divisionID
                ? divisionApiKeyStore.updateDivision()
                : divisionApiKeyStore.createDivision(),
              invalidateRoute: () => divisionApiKeyStore.getDivisions(),
            }}
            data={editItem}
            yupSchema={divisionFormSchema}
            onClose={handleEditClose}
            size="xs"
          >
            <DivisionForm editItem={editItem} />
          </SaveHookFormDialog>
        )}
      </Paper>
    </SiTrackPage>
  );
};
